
import React from "react"
import Image from './index'

function Avatar({object, className = ''}){
    let marks = []
    if(object?.verified === true){
        marks.push('check_mark')
    }
    return(
        <Image src={object.image} marks={marks} className={className}/>
    )
}

export default Avatar